import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Trash2 } from 'blaze-ui/icons'
import { LogoDeletionConfirmationModal } from 'components/LogoDeletionConfirmationModal/LogoDeletionConfirmationModal'
import { useConfirmModal } from 'hooks/useConfirmModal'

interface DeleteButtonProps {
  onDelete: () => void
  isDisabled: boolean
}

export const DeleteButton = ({ onDelete, isDisabled }: DeleteButtonProps) => {
  const confirmDelete = useConfirmModal(LogoDeletionConfirmationModal)

  return (
    <IconButton
      size="sm"
      variant="secondary"
      icon={Trash2}
      onPress={async () => {
        const confirmed = await confirmDelete()
        if (confirmed) {
          onDelete()
        }
      }}
      isDisabled={isDisabled}
      aria-label="Delete"
    />
  )
}
